var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info" },
    [
      _c(
        "el-form",
        {
          ref: "infoForm",
          staticClass: "info-form",
          attrs: { model: _vm.userObject, "label-width": "120px" },
        },
        [
          _c("el-form-item"),
          _c(
            "el-form-item",
            { attrs: { label: "用户头像", prop: "avatarUrl" } },
            [
              _c("upload-picture", {
                attrs: {
                  imageUrl: _vm.userObject.avatarUrl,
                  width: "128px",
                  height: "128px",
                },
                on: { getUrl: _vm.getImage },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "用户ID", prop: "id" } }, [
            _c(
              "div",
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: { placeholder: "请输入用户ID", disabled: "" },
                  model: {
                    value: _vm.userObject.id,
                    callback: function ($$v) {
                      _vm.$set(_vm.userObject, "id", $$v)
                    },
                    expression: "userObject.id",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "用户昵称", prop: "username" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                on: { input: _vm.getName },
                model: {
                  value: _vm.userObject.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "username", $$v)
                  },
                  expression: "userObject.username",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "手机号码", prop: "phone" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "phone", $$v)
                  },
                  expression: "userObject.phone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "OPENID", prop: "openId" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.openId,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "openId", $$v)
                  },
                  expression: "userObject.openId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否会员", prop: "openId" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.isMemberL,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "isMemberL", $$v)
                  },
                  expression: "userObject.isMemberL",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "可提现佣金", prop: "commission" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.commission,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "commission", $$v)
                  },
                  expression: "userObject.commission",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户推荐人ID", prop: "referrerUserId" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.referrerUserId,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "referrerUserId", $$v)
                  },
                  expression: "userObject.referrerUserId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "加入时间", prop: "joinTime" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.joinTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "joinTime", $$v)
                  },
                  expression: "userObject.joinTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "最近访问时间", prop: "lastActiveTime" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.userObject.lastActiveTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.userObject, "lastActiveTime", $$v)
                  },
                  expression: "userObject.lastActiveTime",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }